import { lightErrorToast } from "../Components/customToast";
import requestMethods from "../helpers/request";
import { shifterStatusUpdate } from "./serviceSlice";

export const getStatus = () => {
  return async (dispatch) => {
    try {
      const response = await requestMethods.GET({
        endpoint: "v1/shifter/mobile/get-shifter-status",
      });
      dispatch(shifterStatusUpdate(response));
    } catch (error) {
      lightErrorToast(error.message);
    }
  };
};
